import React from 'react';

const ErrorPage = () => {
  const reloadPage = () => {
    window.location.reload();
  };

  const styles = {
    body: {
      fontFamily: 'Arial, sans-serif',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '90vh',
      margin: 0,
      backgroundColor: '#f0f0f0'
    },
    container: {
      textAlign: 'center',
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    button: {
      padding: '10px 20px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '16px'
    }
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1>Si è verificato un errore.</h1>
        <p>Controlla la tua connessione ad internet e riprova.</p>
        <p>
          Se il problema persiste,{' '}
          <a href="mailto:info@fantaclasse.it">contattaci</a>.
        </p>
        <button onClick={reloadPage} style={styles.button}>
          Ricarica
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
